export const PADDING = Object.freeze({
  extraSmall: '4px',
  smallest: '8px',
  input: '12px',
  small: '16px',
  default: '24px',
  big: '32px',
  biggest: '40px',
});

export const BORDER_RADIUS = Object.freeze({
  small: '4px',
  default: '8px',
  big: '12px',
  biggest: '16px',
  extraBig: '24px',
  round: '100%',
});

export const HEADER_HEIGHT = '96px';
export const BOTTOM_BAR_HEIGHT = '128px';
export const SCROLL_BAR_WIDTH = '10px';
